import { Dispatch, SetStateAction } from 'react';

import useTimeZone from 'hooks/use-timezone';
import { Chassis, Container, Genset } from 'types';

import { useNewTransaction } from '..';

type ManufacturedDateProps<T extends Chassis | Container | Genset> = { unit: T; setUnit: Dispatch<SetStateAction<T>> };

const ManufacturedDate = <T extends Chassis | Container | Genset>({ unit, setUnit }: ManufacturedDateProps<T>) => {
  const { dateInputToUtc, utcToZonedDate } = useTimeZone();
  const { transaction } = useNewTransaction();
  return (
    <div className="text-field">
      <input
        type="date"
        className="w-100"
        disabled={!transaction.inbound}
        ref={node => node?.classList.toggle('blank', !unit.manufacturedDate)}
        value={utcToZonedDate(unit.manufacturedDate)}
        onChange={e => setUnit(prevState => ({ ...prevState, manufacturedDate: dateInputToUtc(e.target.value) }))}
      />
      <label>MANUFACTURED</label>
    </div>
  );
};

export default ManufacturedDate;
